import React, { useState, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, resolveImg } from "@/lib/api";

export default function ImageUpload({ value, onChange, label = "Image" }) {
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      <label className="mb-1.5 block text-sm font-semibold text-slate-700">{label}</label>
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative">
            <img src={resolveImg(value)} alt="preview" className="h-16 w-16 rounded-lg object-cover border border-slate-200" />
            <button type="button" onClick={() => onChange("")} className="absolute -right-2 -top-2 rounded-full bg-red-500 p-0.5 text-white" data-testid="image-remove">
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ) : (
          <div className="flex h-16 w-16 items-center justify-center rounded-lg border border-dashed border-slate-300 bg-slate-50 text-slate-400">
            <Upload className="h-5 w-5" />
          </div>
        )}
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handle} data-testid="image-input" />
        <Button type="button" variant="outline" size="sm" disabled={loading} onClick={() => inputRef.current?.click()} data-testid="image-upload-btn">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Upload from device"}
        </Button>
      </div>
    </div>
  );
}
